<template>
  <comp-twitter :account="account" />
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import CompTwitter from './Twitter'
  export default {
    components: {
      CompTwitter
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
    },
    data: () => ({
      account: null
    }),
    watch: {
      'data.TwitterAccount': {
        handler: function (newValue) {
          this.account = newValue ? newValue : null
        },
        deep: true
      }
    },
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
    mounted () {
      this.account = this.data.TwitterAccount ? this.data.TwitterAccount : null
    }
  }
</script>
<style scoped>
</style>
